<div class="accordion orders__table">
  <div class="orders-table__header" *ngIf="(hybrisOrders | filterByAttributes: filters | searchFilter: searchValue).length > 0; else noHybrisOrders">
    <div *ngFor="let header of headers" class="display-flex" [ngClass]="header.class">
      <div>{{ header.label | translate }}</div>
      <app-sort-by
          [sort]="header.sortOptions"
          [cssClass]="'margin-0'"
          [current]="currentSort"
          [hasTitle]=false
          (selected)="sort($event)">
      </app-sort-by>
    </div>
    <div class="width-10"></div>
  </div>
  <ng-template #noHybrisOrders>
    <span>{{ 'orders-page.no-orders-matching-filter-message' | translate }}</span>
  </ng-template>
  <div class="order-history__table">
    <div class="table-items">
      <app-accordion *ngFor="let order of hybrisOrders | filterByAttributes: filters | searchFilter: searchValue">
        <ng-container ngProjectAs="[slot][header]">
          <div class="accordion__title icon-arrow-down" (click)="toggleTab(order.id)">
            <div class="order-info width-15 order-id">
              <span class="header__label" [attr.data-test]="'label-orderId'">
                {{ 'spare-part-list.order-id' | translate }}:
              </span>
              <span [attr.data-test]="'desc-orderId'">
                {{ order?.id }}
              </span>
            </div>
            <div class="order-info width-20 order-date">
              <span class="header__label" [attr.data-test]="'label-orderDate'">
                {{ 'spare-part-list.date-ordered-by' | translate }}:
              </span>
              <span [attr.data-test]="'desc-orderDate'">
                {{ order.attributes?.orderCreationDate | formatDate }}
              </span>
              <span class="greyed-out" [attr.data-test]="'desc-customer'">
                {{ order.attributes?.userName }}
              </span>
            </div>
            <div class="order-info width-25 order-equipment">
              <span class="header__label" [attr.data-test]="'label-orderEquipment'">
                {{ 'spare-part-list.equipment' | translate }}:
              </span>
              <span [attr.data-test]="'desc-orderEquipmentNumber'">
                {{ order.attributes?.equipment}}
              </span>
            </div>
            <div class="order-info width-15 order-status">
              <span class="header__label" [attr.data-test]="'label-orderStatus'">
                {{ 'spare-part-list.order-status' | translate }}:
              </span>
              <div class="display-flex justify-content-center flex-column">
                <div class="order-status__icon">
                  <span class="status__icon"
                        [attr.data-test]="'icon-orderStatus'"
                        [ngClass]="getStatusIcon(order.attributes?.orderStatus)">
                  </span>
                  <span class="status__name" [attr.data-test]="'desc-orderStatus'">
                    {{ getFormattedStatus(order.attributes?.orderStatus) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="order-info width-15 total">
              <span class="header__label" [attr.data-test]="'label-totalPrize'">
                {{ 'spare-part-list.total' | translate }}:
              </span>
              <div class="price">
                <span [attr.data-test]="'desc-totalPrize'">
                  {{ order.attributes?.orderTotal | currency: 'USD' }}
                </span>
                <div class="order-items-count">
                  <ng-container *ngIf="order.attributes?.items.length > 1">
                    <span [attr.data-test]="'desc-quantity'">
                      {{ 'spare-part-list.item-plural' | translate:{number: getOrderQuantity(order)} }}
                    </span>
                  </ng-container>
                  <ng-container *ngIf="order.attributes?.items.length === 1">
                    <span [attr.data-test]="'desc-quantity'">
                      {{ 'spare-part-list.item-singular' | translate:{number: getOrderQuantity(order)} }}
                    </span>
                  </ng-container>
                </div>
              </div>
              <span class="additional-info "></span>
            </div>
            <div class="width-10"></div>
          </div>
        </ng-container>
        <ng-container ngProjectAs="[slot][panel]">
          <div class="container accordion__content">
            <app-spare-part-hybris-item-details
                [orderDetails]="order"
                [isOpen]="tabsOpened.includes(order.id)">
            </app-spare-part-hybris-item-details>
          </div>
        </ng-container>
      </app-accordion>
    </div>
  </div>
</div>
